import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { authInterceptorProviders } from './../_helpers/auth.interceptor';
import { EnrolTrialComponent } from './enrol-trial/enrol-trial.component';
import { EnrolUpgradeComponent } from './enrol-upgrade/enrol-upgrade.component';
import { EnrolmentStudentListComponent } from './enrolment-student-list/enrolment-student-list.component';

import { MathModule } from './../math/math.module';
import { QuizModule } from './../quiz/quiz.module';
import { RegisterStudentComponent } from './register-student/register-student.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from './../shared/shared.module';


import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DataTablesModule } from 'angular-datatables';
import { FlutterwaveModule } from 'flutterwave-angular-v3';
import { StudentCertAwardingComponent } from './student-cert-awarding/student-cert-awarding.component';
import { StudentGiftAreaComponent } from './student-gift-area/student-gift-area.component';
import { StudentHomeShowComponent } from './student-home-show/student-home-show.component';
import { StudentMessageCreateComponent } from './student-messaging/student-message-create/student-message-create.component';
import { StudentMessageShowComponent } from './student-messaging/student-message-show/student-message-show.component';
import { StudentMessagingCombinedTabComponent } from './student-messaging/student-messaging-combined-tab/student-messaging-combined-tab.component';
import { StudentMessagingHomeComponent } from './student-messaging/student-messaging-home/student-messaging-home.component';
import { StudentMessagingReceivedTabComponent } from './student-messaging/student-messaging-received-tab/student-messaging-received-tab.component';
import { StudentMessagingSentTabComponent } from './student-messaging/student-messaging-sent-tab/student-messaging-sent-tab.component';

import { AwardListGuardianComponent } from './award-list-guardian/award-list-guardian.component';
import { AwardListStudentComponent } from './award-list-student/award-list-student.component';
import { DashboardHomeComponent } from './dashboard-home/dashboard-home.component';
import { StudentAwardShowComponent } from './student-award-show/student-award-show.component';

import { BarChartWeeklyReportComponent } from './bar-chart-weekly-report/bar-chart-weekly-report.component';
import { EnrolAdminExtendComponent } from './enrol-admin-extend/enrol-admin-extend.component';
import { ReportGuardianStudentComponent } from './report-guardian-student/report-guardian-student.component';
import { ReportGuardianComponent } from './report-guardian/report-guardian.component';
import { ReportHomeComponent } from './report-home/report-home.component';
import { ReportStudentComponent } from './report-student/report-student.component';




@NgModule({
  declarations: [
    StudentHomeShowComponent,
    StudentCertAwardingComponent,
    StudentGiftAreaComponent,
    StudentMessagingHomeComponent,
    StudentMessagingSentTabComponent,
    StudentMessagingReceivedTabComponent,
    StudentMessagingCombinedTabComponent,
    StudentMessageCreateComponent,
    StudentMessageShowComponent,
    RegisterStudentComponent,
    EnrolUpgradeComponent,
    EnrolTrialComponent,
    EnrolmentStudentListComponent,
    StudentAwardShowComponent,
    DashboardHomeComponent,
    AwardListStudentComponent,
    AwardListGuardianComponent,

    ReportHomeComponent,
    ReportStudentComponent,
    ReportGuardianComponent,
    ReportGuardianStudentComponent,
    BarChartWeeklyReportComponent,
    EnrolAdminExtendComponent

  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    DataTablesModule,
    MathModule,
    QuizModule,
    FlutterwaveModule,
    AngularMyDatePickerModule
  ],
  exports: [
    StudentHomeShowComponent,
    StudentCertAwardingComponent,
    StudentGiftAreaComponent,
    StudentMessageCreateComponent,
    RegisterStudentComponent,
    EnrolTrialComponent,
    EnrolmentStudentListComponent
  ],
  providers:[
    authInterceptorProviders
  ]
})
export class StudentModule { }
